module.exports = __webpack_public_path__ + "static/media/image-placeholder.4848e38a.png";